import { DiscountTypes } from "@/common/enums";

export default class ChaseSettingsModel {
    secureId: string = "";    
    apiKey: string = "";    
}
